module.exports = __webpack_public_path__ + "img/tips4.672c9fcd.png";